module.exports = __webpack_public_path__ + "img/eth.733f6193.svg";